<template>
    <div>
        <div class="syalert" v-html="text"></div>

        <div class="syconfirm" v-if="cshow === 1">
            <div class="syconfirm-bg" @click="sycfunc(0)"></div>
            <div class="syconfirm-op">
                <span style="color: #000000;font-size: 0.8rem;">{{ctext}}</span>
                <span class="sy_btn_white_red" @click="sycfunc(1)">{{ctips}}</span>
            </div>
        </div>

</div>
</template>
<script>
    export default {
        name: "syalert",
        //   props: {
        //     text: {
        //       type: String,
        //       default: "",
        //     },
        //   },
        data() {
            return {
                text: "",
                cfunc: {},
                ctext: "",
                ctips: "",
                cshow: 0,
            };
        },
        methods: {

            /**
             * 提示 
             * 信息 msg 
             * 时间 time 单位毫秒
             * 回调 callback
             * 
             * 
            */
            syalert: function(msg, time, callback)
            {
				// ----- ----- 实例重命名
                let $_this = this;
                if (time === undefined)
                {
                    time = 3000
                }

                $_this.text = "<div><div>" + msg + "</div></div>";
                setTimeout(function() {
                    $_this.text = "";
                    if( callback !== undefined )
                    {
                        callback();
                    }
                }, time);
            },
            // 确认框 确认文本 提示文本 回调函数
            syconfirm: function(ctext, ctips, cfunc) { 
                this.cshow = 1;
                this.ctips = ctips;
                this.ctext = ctext;
                this.cfunc = cfunc;
                
                return 11;
            },
            sycfunc: function(tag) {
                this.cshow = 0;
                if( tag == 1 )
                {
                    this.cfunc(tag);
                }
            },
        },
    };


/*
使用方法
$_this.$refs.syalert_id.syalert('复制失败');
$_this.$refs.syalert_id.syconfirm(res.msg, '确定', function()
{
});


*/


</script>
<style>
    .syalert>div
    {
        position: fixed;

        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        line-height: 10rem;

        border-radius: 0.5rem;
        margin: 0 auto;
        color: white;
        text-align: center;
        background: rgba(0, 0, 0, 0.1);
    }

    .syalert>div>div{
        position: fixed;

        top: calc(50% - 5rem);
        left: 25%;

        width: 50%;
        height: 10rem;
        line-height: 10rem;

        border-radius: 0.5rem;
        margin: 0 auto;
        color: white;
        font-size: 0.6rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
    }
    .syconfirm {
        position: fixed;
        
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
    }
    .syconfirm-bg {
        position: absolute;

        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        
        background: rgba(0, 0, 0, 0.5);
    }

    .syconfirm-op  {
        position: fixed;

        top: calc(50% - 5rem);
        left: 10%;

        width: 80%;
        height: 10rem;
        line-height: 10rem;

        border-radius: 0.5rem;
        margin: 0 auto;
        color: white;
        text-align: center;
        background: rgba(255, 255, 255, 1);
    }
    .sy_btn_white_red
    {
        position: fixed;
        
        top: calc(50% + 1.5rem);
        left: calc(50% - 3rem);
    
        width: 50%;
    
        color: white;
        margin: 0.8rem auto;
        display: block;
        clear: both;
        width: 6rem;
        height: 1.8rem;
        
        
        font-size: 1.0rem;
        
        border-radius: 0.3rem;
        background-color: rgb(255, 96, 96);
        border: 0;
        line-height: 1.8rem;
    }  
    
    
</style>